module.exports = __webpack_public_path__ + "static/img/icon_nav_help_mine.d6ca140a.png";